import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './draft-recovery.css';

export default function DraftRecoveryPrompt({ onRestore, onRestart }: {
  onRestore: () => void;
  onRestart: () => void;
}) {
  const restoreRef = useRef<HTMLButtonElement>(null);
  const restartRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    restoreRef.current?.focus({ preventScroll: true });
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const keydown = (event: KeyboardEvent) => {
      // Escape 或点击遮罩均不替用户恢复/清空草稿。
      if (event.key === 'Escape') event.preventDefault();
      if (event.key !== 'Tab') return;
      event.preventDefault();
      const next = document.activeElement === restoreRef.current ? restartRef.current : restoreRef.current;
      next?.focus();
    };
    document.addEventListener('keydown', keydown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', keydown);
    };
  }, []);

  return createPortal(
    <div className="draft-recovery-backdrop">
      <div className="draft-recovery-dialog" role="dialog" aria-modal="true" aria-labelledby="draft-recovery-title" aria-describedby="draft-recovery-description">
        <h2 id="draft-recovery-title">恢复上次填写？</h2>
        <div id="draft-recovery-description">
          <p>发现这份问卷有未提交的内容。恢复后将保留上次的答案，并定位到上次最后填写的题目。</p>
          <p>选择“重新填写”将清空本机草稿，从问卷开头开始。</p>
          <p className="draft-recovery-note">附件与签名需重新上传或签署。</p>
        </div>
        <div className="draft-recovery-actions">
          <button ref={restartRef} type="button" className="btn" onClick={onRestart}>重新填写</button>
          <button ref={restoreRef} type="button" className="btn btn-primary" onClick={onRestore}>恢复上次填写</button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
